import BaseServiceCrud from './BaseServiceCrud';

export default class DashboardService extends BaseServiceCrud {
    constructor() {
        super();
        this.path = 'dashboard';
    }
    getCriteria(criteria) {
        return this.objToQueryString({});
    }

    getAccommodationMarkers() {
        let url = `${this.domain}/${this.path}/marker/accommodation`;
        return this.fetch(url, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
    getProjectMarkers() {
        let url = `${this.domain}/${this.path}/marker/project`;
        return this.fetch(url, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
}
